// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3jO4i","actions":"GroupTable_actions__2AkTy","deleteModalFooter":"GroupTable_deleteModalFooter___NRBJ"};